var _excluded = ["eventName"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import analytics from "@xo-union/tk-analytics";
import getMappableValue from "../getMappableValue.js";
export var useTrackImpression = function useTrackImpression(_ref) {
  var eventName = _ref.eventName,
    eventData = _objectWithoutProperties(_ref, _excluded);
  React.useEffect(function () {
    analytics.track(eventName, eventData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
var trackImpression = function trackImpression(propMap) {
  var decorator = function decorator(DecoratedComponent) {
    var ImpressionTracker = function ImpressionTracker(props) {
      var event = getMappableValue(propMap, props);
      useTrackImpression(event);
      return /*#__PURE__*/React.createElement(DecoratedComponent, props);
    };
    return ImpressionTracker;
  };
  return decorator;
};
export default trackImpression;